module.exports = __webpack_public_path__ + "media/images/ellipsis-50px-d137c038d81dc96f88331779352c8db2.gif";